import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRM, fmtNum, fmtDate } from "../../lib/format";
import { useLang } from "../../lib/i18n";
import { StatCard, PageTitle, StatusBadge, Spinner } from "../../components/Shell";
import { Building2, Wallet, Users, TrendingUp } from "lucide-react";

export default function Overview() {
  const [data, setData] = useState(null);
  const { lang } = useLang();

  useEffect(() => {
    api.get("/platform/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <Spinner />;

  return (
    <div data-testid="platform-overview">
      <PageTitle title={lang === "bm" ? "Ringkasan Platform" : "Platform Overview"} sub="KOPERA — SaaS Owner Dashboard" />
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <StatCard testid="stat-tenants" label={lang === "bm" ? "Jumlah Koperasi" : "Total Tenants"} value={fmtNum(data.tenants_total)} icon={Building2} sub={`${data.tenants_by_status?.active || 0} aktif • ${data.tenants_by_status?.trial || 0} trial`} />
        <StatCard testid="stat-mrr" label="MRR" value={fmtRM(data.mrr)} icon={Wallet} sub={`ARR ${fmtRM(data.arr)}`} />
        <StatCard testid="stat-members" label={lang === "bm" ? "Jumlah Ahli" : "Total Members"} value={fmtNum(data.total_members)} icon={Users} />
        <StatCard testid="stat-leads" label={lang === "bm" ? "Lead CRM" : "CRM Leads"} value={fmtNum(data.leads_total)} icon={TrendingUp} sub={`${data.leads_by_stage?.["NEW LEAD"] || 0} baharu`} />
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <div className="bg-card rounded-xl border border-brand-deep/10 p-5">
          <h3 className="font-display font-semibold text-brand-dark mb-4">{lang === "bm" ? "Koperasi Terkini" : "Recent Tenants"}</h3>
          <div className="space-y-3">
            {data.recent_tenants.map((t) => (
              <div key={t.tenant_id} className="flex items-center justify-between gap-3 text-sm">
                <div className="min-w-0">
                  <div className="font-medium text-brand-dark truncate">{t.name}</div>
                  <div className="text-xs text-muted-foreground">{t.slug}.kopera.app • {fmtDate(t.created_at)}</div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-xs font-semibold uppercase text-brand-deep">{t.plan}</span>
                  <StatusBadge status={t.status} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-card rounded-xl border border-brand-deep/10 p-5">
          <h3 className="font-display font-semibold text-brand-dark mb-4">{lang === "bm" ? "Bayaran Langganan Terkini" : "Recent Subscription Payments"}</h3>
          {data.recent_payments.length === 0 ? (
            <p className="text-sm text-muted-foreground">{lang === "bm" ? "Tiada bayaran lagi." : "No payments yet."}</p>
          ) : (
            <div className="space-y-3">
              {data.recent_payments.map((p) => (
                <div key={p.session_id} className="flex items-center justify-between text-sm">
                  <div>
                    <div className="font-medium text-brand-dark">{p.lookup_key}</div>
                    <div className="text-xs text-muted-foreground font-mono">{p.session_id.slice(0, 24)}…</div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono font-semibold text-brand-deep">{(p.amount_sen / 100).toLocaleString("ms-MY", { style: "currency", currency: p.currency?.toUpperCase() || "MYR" })}</div>
                    <StatusBadge status={p.payment_status} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
